import dayjs from 'dayjs'
import { motion } from 'framer-motion'
import qs from 'qs'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { inSpareRoom, inSpareRoomCheck, verityRoomUser } from '@/api/center'
import { checkDevice } from '@/hooks/useCheckDevice'
import { deviceInfoStore, useSetRecoilState } from '@/store'

import Modal from '../Modal'

const { deviceShowState } = deviceInfoStore
const tipMap = {
  info: '请输入课堂房间号',
  error: '请输入正确的房间号',
  success: '请输入课堂房间号'
}

const tabs = [
  {
    name: '1对1临时课堂',
    type: '1v1'
  }
  // {
  //   name:'小班临时课堂',
  //   type:'xbk',
  // },
]

interface IProps {
  cancel: () => void
}

export default ({ cancel }: IProps) => {
  const [focusNum, setFocusNum] = useState<number>(0)
  const [roomNumList, setRoomNumList] = useState<string[]>(['', '', '', '', '', ''])
  const [inputDomList, setInputDomList] = useState<any>([])
  const [tipText, setTipText] = useState<string>(tipMap.info)
  const [errorTip, setErrorTip] = useState<boolean>(false)
  // 一个字都没输入要置灰
  const [isGary, setIsGary] = useState<boolean>(true)
  // tab切换类型
  const [tabType, setTabType] = useState<string>('1v1')
  const [tipState, setTipState] = useState(false)
  const setDeviceShow = useSetRecoilState(deviceShowState)
  const navigate = useNavigate()

  useEffect(() => {
    const dom = document.querySelector('.input-box')
    if (dom) {
      const domList = dom.querySelectorAll('input') || []
      setInputDomList(domList)
      changeFocus(0)
    }
  }, [])

  const close = (): void => {
    cancel()
  }
  // 键盘事件
  const keyDown = (e: any): void => {
    if (e.keyCode === 13) {
      getDeviceChange()
      return
    }
    if (e.keyCode === 8) {
      keyDel(e)
      return
    }

    let key = -1
    if (e.keyCode > 47 && e.keyCode < 58) {
      key = Number(String.fromCharCode(e.keyCode))
    } else if (e.keyCode > 95 && e.keyCode < 106) {
      key = e.keyCode - 96
    }

    if (key > -1) {
      setRoomNumList((val) => {
        return val.map((v, i) => {
          if (focusNum === i) {
            return `${key}`
          }
          return v
        })
      })
      setIsGary(false)
      changeFocus(focusNum + 1)
    } else {
      setRoomNumList((val) => {
        return val.map((v, i) => {
          if (focusNum === i) {
            return ''
          }
          return v
        })
      })
    }
  }
  // 键盘删除事件
  const keyDel = (e: Event): void => {
    if (focusNum >= 0) {
      if (focusNum === 0) {
        setTipText(tipMap.info)
        setErrorTip(false)
      }
      setRoomNumList((val) => {
        return val.map((v, i) => {
          if (focusNum === i) {
            return ''
          }
          return v
        })
      })
      focusNum > 0 && changeFocus(focusNum - 1)
      setIsGary(true)
      roomNumList.forEach((el) => {
        if (el !== '') {
          setIsGary(false)
        }
      })
    }
  }
  // 改变焦点
  const changeFocus = (index: number): void => {
    if (index >= 6) {
      return
    }
    inputDomList[index] && inputDomList[index].focus()
    setFocusNum(index)
  }
  // 清空
  const clear = (): void => {
    // this.$set(this, 'roomNumList', ['', '', '', '', '', '']);
    setRoomNumList(['', '', '', '', '', ''])
    changeFocus(0)
    setTipText(tipMap.info)
    setErrorTip(false)
  }
  // 错误提示
  const errorTipMsg = (msg: string): void => {
    setTipText(msg)
    setErrorTip(true)
  }
  // 设备检测
  const getDeviceChange = async () => {
    const empty = roomNumList.findIndex((el) => {
      return el === ''
    })
    if (empty !== -1) {
      errorTipMsg(tipMap.error)
      console.log('请输入正确的房间号')
      return
    }
    // 设备检测
    const res = await checkDevice()
    if (!res) {
      setTipState(true)
      return
    }
    toTempRoom()
  }
  const toTempRoom = async () => {
    const roomId = roomNumList.join('') || '888888'
    //  todo 全局取
    const userId = localStorage.getItem('userid') || '4127414'

    const param = {
      roomId,
      userId,
      errorMsg: errorTipMsg,
      type: tabType
    }

    const verity = await verityRoomUser({ cname: roomId })
    console.log('----1111,111---', verity)
    if (~~verity.status !== 0) {
      toast.error(verity.msg)
      return
    }
    const verityInfo = verity.roomInfo
    try {
      const users = verityInfo.users
      if (users.length) {
        const studentUsers = users.filter((item: any) => item.role == 1)
        if (studentUsers.length) {
          const exsitUser = users.some((item: any) => item.userid.substr(2) === userId)
          if (!exsitUser) {
            toast.error('房间内已有学生')
            return
          }
        }
      }
    } catch (err) {
      toast.error(err.msg)
    }

    const { status, data } = await inSpareRoom({
      roomId,
      userId
    }).catch((err) => {
      toast.error(err.msg)
    })

    const { data: inSpareRoomCheckRes } = await inSpareRoomCheck({ userId })

    let result = data
    if (status !== 0) {
      result = {}
    }
    const formData = qs.stringify({
      userId,
      roomId,
      ...result,
      ...inSpareRoomCheckRes,
      roomType: 0,
      classTime: dayjs().unix()
    })
    console.log('formData', formData)
    // window.location.href = import.meta.env.VITE_APP_home + '/classclient/#/?' + formData
    navigate(`/room?${formData}`)
  }

  return (
    <Container>
      <i className="iconfont close anim_btn2" onClick={close}>
        &#xe625;
      </i>
      <div className="temp-tabs">
        {tabs.map((item, i) => (
          <span key={i} className={`${tabType == item.type ? 'active' : ''}`} onClick={() => setTabType(item.type)}>
            {item.name}
          </span>
        ))}
      </div>
      <div className="icon-box">
        <span style={{ color: errorTip ? 'red' : '' }}>{tipText}</span>
      </div>
      <div className="input-box">
        {roomNumList.map((v, i) => (
          <input
            key={i}
            value={v}
            type="text"
            maxLength={1}
            min="0"
            max="9"
            autoComplete="off"
            onKeyUp={keyDown}
            onChange={() => {}}
            onFocus={() => changeFocus(i)}
            // @keyup.prevent="keyDown"
            // @keyup.delete="keyDel"
            // @focus="changeFocus(index)"
          />
        ))}
      </div>
      <div className="button-box">
        <div className="clear anim_btn2" onClick={clear}>
          清空
        </div>
        {/* <!--     todo 需要评估v-scale 组件是否需要动态开关       --> */}
        {!isGary ? (
          <div className="inter anim_btn2" onClick={getDeviceChange}>
            进入房间
          </div>
        ) : (
          <div className="inter inter-gray">进入房间</div>
        )}
      </div>

      <Modal
        shadowClick={false}
        show={tipState}
        cancel={() => {
          setTipState(false)
          toTempRoom()
        }}
        header=""
        confirm={() => {
          setTipState(false)
          setDeviceShow(true)
        }}
        cancelText="暂不检测"
      >
        <div className="mx-auto my-[20px] w-[300px]">您尚未通过设备检测，可能影响上课，是否立即检测？</div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  width: 400px;
  background: #ffffff;
  border-radius: 24px;
  text-align: center;
  position: relative;
  .close {
    position: absolute;
    color: #cccccc;
    right: 0;
    top: 0;
  }
  .temp-tabs {
    line-height: 24px;
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    & > span {
      padding: 0 12px;
      font-size: 20px;
      color: #666;
      font-size: 16px;
      cursor: pointer;
      height: 30px;
      &::before {
        content: '';
        left: 30px;
        transition: left 0.1s ease-in-out;
      }
      &.active {
        color: #ff575f;
        position: relative;
        font-weight: 500;
        &::before {
          position: absolute;
          display: block;
          left: 50%;
          bottom: 0;
          margin-left: -16px;
          width: 32px;
          height: 4px;
          background: #ff5050;
          border-radius: 2px;
        }
      }
    }
  }
  .icon-box {
    text-align: left;
    padding-left: 42px;
    .iconfont {
      width: 80px;
      height: 80px;
      display: block;
      background-color: rgba(255, 236, 236, 1);
      border-radius: 100%;
      margin: 32px auto 12px;
      color: rgba(255, 80, 80, 1);
      font-size: 32px;
      line-height: 80px;
    }
    span {
      font-size: 16px;
      font-weight: 300;
      color: #999999;
      line-height: 16px;
    }
  }
  .input-box {
    display: flex;
    margin-top: 16px;
    padding: 0 40px;
    justify-content: space-around;
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
    input {
      width: 48px;
      height: 48px;
      background: #f5f5f5;
      box-shadow: inset 1px 1px 3px 0 rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      box-sizing: border-box;
      border: none;
      outline-style: none;
      text-align: center;
      &:focus {
        border: 2px solid #ff5050;
      }
    }
  }
  .button-box {
    display: flex;
    justify-content: space-around;
    padding: 0 30px;
    margin-top: 40px;
    font-weight: 500;
    .inter {
      width: 156px;
      height: 48px;
      background: #ff5050;
      box-shadow: 0px 4px 0px 0px #d1385f;
      border-radius: 25px;
      color: #fff;
      line-height: 48px;
    }
    .inter-gray {
      background: #e3e3e3;
      box-shadow: 0px 4px 0px 0px #d7d7d7;
      color: #ffffff;
      cursor: pointer;
    }
    .clear {
      width: 156px;
      height: 48px;
      background: #fff4f4;
      box-shadow: 0px 4px 0px 0px #fbe7e7;
      border-radius: 25px;
      color: #ff5050;
      line-height: 48px;
    }
  }

  .fade-enter-active {
    animation: fade-in 1s ease-out;
  }

  .fade-leave-active {
    animation: fade-in 0.6s reverse ease-in;
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
